import React from 'react'
import { DefaultTooltipContent } from 'recharts/lib/component/DefaultTooltipContent'

class CustomTooltipContent extends React.Component {
	render() {
		const { payload, dataKey, t } = this.props
		if (payload && payload.length && payload[0] != null) {
			let newPayload
			if (typeof payload[0].payload.value === 'object') {
				if (dataKey) {
					newPayload = [
						{
							name: t(dataKey),
							value: t(payload[0].payload.value[dataKey]),
						},
					]
				} else {
					newPayload = Object.keys(payload[0].payload.value).map(v => {
						return {
							name: t(v),
							value: t(payload[0].payload.value[v]),
						}
					})
				}
			} else {
				newPayload = [
					{
						name: t(payload[0].payload.key),
						value: t(payload[0].payload.value),
					},
				]
			}
			return <DefaultTooltipContent {...this.props} payload={newPayload} />
		}

		return <DefaultTooltipContent {...this.props} />
	}
}

export default CustomTooltipContent
